import { logUsage, PerformanceDatapoint } from 'owa-analytics';

type TeamsServiceTelemetry = {
    step: 'Auth' | 'Request' | 'Response';
    service: string;
    context?: string;
};
type TeamsServiceErrorTelemetry = TeamsServiceTelemetry & {
    error: 'Empty_Token' | 'Response_Empty' | 'Unknown';
};

export function logPerf(): PerformanceDatapoint {
    return new PerformanceDatapoint('AppServiceFetch_Network');
}

export function logError(params: TeamsServiceErrorTelemetry) {
    logUsage('AppServiceFetch_Failure', params);
}

export function log(params: TeamsServiceTelemetry) {
    logUsage('AppServiceFetch_Usage', params);
}
